<template>
  <div class="m-order shop-order shop-view">
      <div class="order-header"></div>
      <div class="order-view">
          <div class="order-wrapper">
              <div class="user-info clearfix">
                <span class="user-name"><em v-if="$store.state.userinfo.areaId">【{{ $queryArea($store.state.userinfo.areaId) }}】</em>{{ $store.state.userinfo.name || $store.state.ua.account || '仙术师' }}</span>
              </div>

              <div class="order-list">
                  <ul v-if="order_list.length">
                      <li v-for="(item,index) in order_list" :key="index">
                          <h6>{{ item.shopName }}</h6>
                          <div class="item-detail clearfix">
                              <div class="pic f-l"><div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div></div>
                              <div class="item-info f-l">
                                  <h6 class="item-name">{{ item.name }}</h6>
                                  <div class="now">实付：<em class="icon-m3b"></em><span>{{ item.priceFinal }}</span></div>
                              </div>
                              <div class="u-btn order-detail" v-bind:data-gid="item.id" @click="orderDetail(item)">订单详情></div>                         
                          </div>                                                     
                      </li>
                  </ul>
                  <div class="notice" v-else>
                      <h5>您还没有相关订单</h5>
                      <p><router-link to="/bazaar"> 可以去集市看看有没有想买的~</router-link></p>
                  </div> 
              </div>
          </div>
      </div>

      <recommend></recommend>

      <div class="bottom-bubble">
          <div class="txt-bubble"></div>
          <div class="u-btn u-top"></div>
      </div>        

  </div>
</template>

<script>
import recommend from '@/components/recommend.vue'

export default {
  components : {
    'recommend' : recommend,
  },  
  data () {
    return {
      order_list : [],
    }
  },
  created (){
    if(!parseInt(this.$store.state.login)){
      this.$router.push('/')
      return this.$mslogin.open();
    }
    if(!this.$store.state.userinfo){
      this.$router.push('/')
      return this.$toast('请先选择大区');
    }

    this.render();
  },
  methods : {
    orderDetail (data){
      this.$order_detail({
        data : data
      });
    },
    render (){
      this.$axios.get(this.$ajax_url_map.order)
      .then(res => {
        if(res.code != 0)return;
        this.order_list = res.data.list;
      },rej => {
        this.$toast(rej.message)
      })
    },
  },
}
</script>

<style>
/* order */
.shop-order {
    padding-top: 10px;
    background-image: url(~@/assets/images/body-basket.jpg);
    background-size: 750px auto;
    background-repeat: repeat-y;
}

.order-header {
    width: 750px;
    height: 166px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/bg-order-top_2.png);
}

.user-info {
    color: #dcc4b1;
}

.order-view {
    min-height: 200px;
    margin-top: -1px;
    margin-bottom: 20px;
    background:
        url(~@/assets/images/bg-order-bottom.png) center bottom no-repeat,
        url(~@/assets/images/bg-order-body.png) center top repeat-y;

    background-size: auto 64px, auto 25px;
}

.order-wrapper {
    padding: 0 20px;
}

.order-list {
    margin-top: 25px;
    padding-bottom: 40px;
}

.order-view li {
    position: relative;
    width: 711px;
    height: 215px;
    margin: 0 auto;
    padding: 25px 40px 0 40px;
    color: #683d1e;
    background-image: url(~@/assets/images/item-order.png);
    box-sizing: border-box;
}

.order-view h6 {
    position: relative;
    margin-top: -12px;
    margin-bottom: 12px;
    font-size: 28px;
    font-weight: 700;
    color: #683d1e;
}

.order-view .pic {
    display: flex;
    justify-content: center;
    align-items: center;  
    position: relative;
    width: 113px;
    height: 112px;
    background-image: url(~@/assets/images/bg-item_2.png);
}

.order-view .pic img {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}

.order-view .goods-detail {
    padding-top: 15px;
    padding-left: 115px;
}

.order-view .item-info {
    margin-top: 15px;
    margin-left: 15px;
}

.order-view .item-name {
    margin: 0 0 5px;
    color: #683d1e;
    font-weight: 700;
}

.order-view .now span {
    font-size: 28px;
    font-weight: 700;
    color: #d33d27;
}

.order-view .p-before {
    padding-left: 8px;
    color: #ad7239;
    text-decoration: line-through;
}

.u-btn.order-detail {
    position: absolute;
    right: 30px;
    top: 25px;
}

.notice{
  padding: 40px 0;
  text-align: center;
}

.notice h5{
  font-size: 40px;
  margin-bottom: 20px;
  color: #aa754f;
}

.notice a{
  color: #ad7239;
}
</style>



// WEBPACK FOOTER //
// src/views/order.vue